export const randomString = (length) => {
    return [...Array(length)]
        .map(() => Math.random().toString(36).charAt(2)) // `toString(36)` converts to base-36 (0-9, a-z)
        .join("");
};
//# sourceMappingURL=randomString.js.map